import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';

import GenericShareableLinkBox from './generic_shareable_link_box';
import CreateShareLink from './create_share_link';
import ShareTokenList from './share_token_list';

export default class ShareContentModal extends Component {
    static propTypes = {
        allShareTokens: PropTypes.arrayOf(
            PropTypes.shape({
                access_level: PropTypes.string,
                campaign_id: PropTypes.number,
                id: PropTypes.number,
                token: PropTypes.string
            })
        ),
        header: PropTypes.string.isRequired,
        body: PropTypes.element.isRequired,
        genericShareableLink: PropTypes.string,
        show: PropTypes.bool.isRequired,
        onHide: PropTypes.func.isRequired,
        onShareSucceed: PropTypes.func.isRequired,
        email: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            showShareTokens: false,
            allShareTokens: props.allShareTokens
        };
    }

    handleAlreadySharedClick = e => {
        e.preventDefault();
        this.setState({
            showShareTokens: true
        });
    };

    handleShareSucceed = shareToken => {
        const {allShareTokens} = this.state;
        const {onShareSucceed} = this.props;
        const newAllShareTokens = allShareTokens.concat([shareToken]);

        this.setState({
            allShareTokens: newAllShareTokens
        });

        if (onShareSucceed) onShareSucceed();
    };

    handleShareDelete = (shareToken, i) => {
        const {allShareTokens} = this.state;
        const {displayEmailDeletedSuccess} = this.props;
        const newSharetokens = [...allShareTokens.slice(0, i), ...allShareTokens.slice(i + 1)];

        this.setState({
            allShareTokens: newSharetokens
        });

        if (displayEmailDeletedSuccess) displayEmailDeletedSuccess();
    };

    displayShareTokenList() {
        const {allShareTokens, showShareTokens} = this.state;
        const filteredTokens = allShareTokens.filter(t => !!t.email);

        if (showShareTokens) {
            return (
                <ShareTokenList
                    shareTokens={filteredTokens}
                    onShareDelete={this.handleShareDelete}
                />
            );
        }
    }

    render() {
        const {allShareTokens, showShareTokens} = this.state;
        const {header, body, genericShareableLink, show, onHide} = this.props;
        const shareTokenList = this.displayShareTokenList();

        return (
            <Modal show={show} className="share-content-modal" onHide={onHide}>
                <div className="close-button" onClick={onHide} />
                <div className="share-content-header">
                    <img className="lightbulb-icon" src={require('images/icons/lightbulb.png')} />
                    <h2>{header}</h2>
                    <p>{body}</p>
                    <img
                        className="share-img"
                        src={require('images/admin/campaign_analytics/share_modal/share-img.png')}
                    />
                </div>

                <div className="share-content-body">
                    <GenericShareableLinkBox
                        campaignId={this.props.campaignId}
                        campaignName={this.props.campaignName}
                        brandName={this.props.brandName}
                        link={genericShareableLink}
                        email={this.props.email}
                        handleGetShareableLinkClick={this.props.handleGetShareableLinkClick}
                        handleRemoveShareableLinkClick={this.props.handleRemoveShareableLinkClick}
                    />

                    <div className="share-content-separator">
                        <hr />
                        <div className="separator-or">OR</div>
                        <hr />
                    </div>

                    {shareTokenList}

                    <CreateShareLink
                        campaignId={this.props.campaignId}
                        campaignName={this.props.campaignName}
                        brandName={this.props.brandName}
                        allShareTokens={allShareTokens}
                        onAlreadySharedClick={this.handleAlreadySharedClick}
                        onShareSucceed={this.handleShareSucceed}
                        showAlreadyShared={!showShareTokens}
                        email={this.props.email}
                    />
                </div>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./components/share_content_modal/index.js